import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { SkippableFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { SkipButtonGroup } from '../skip-button-group/component';
import { useSkipWithAnalytics } from '../../../hooks/skin/use-skip';

interface Props {
    className?: string;
    currentFragment: SkippableFragment;
}

export const RecapSkipButtonGroup: FC<Props> = ({ currentFragment, className }) => {
    const { isSkipEnabled, skip, cancel, onSkipButtonShow } = useSkipWithAnalytics(currentFragment);
    const intl = useIntl();

    if (!isSkipEnabled) {
        return null;
    }

    return (
        <SkipButtonGroup
            cancelButtonText={intl.formatMessage({
                id: 'features.player.c00cfed67a57caf97cb6ee73201b0a04',

                defaultMessage: 'Watch recap',
                description: 'Текст для просмотра повтора в группе кнопок в плеере',
            })}
            onSkipClick={skip}
            onCancelClick={cancel}
            className={className}
            onSkipButtonShow={onSkipButtonShow}
        />
    );
};
